(() => {
  const ACCESS_GRANTED_CLASS = 'c24h-access-granted';

  const codeAccessIsGranted = (container) => {
    if (!container || container.dataset.c24hCodeAware !== 'true') return false;
    return document.documentElement.classList.contains(ACCESS_GRANTED_CLASS);
  };

  const closePopup = (toggle, popup, restoreFocus = false) => {
    if (!toggle || !popup) return;
    popup.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle.focus();
  };

  const syncAccessState = (scope = document) => {
    scope.querySelectorAll('[data-c24h-account-root]').forEach((root) => {
      const granted = codeAccessIsGranted(root);
      const popupTrigger = root.querySelector('[data-c24h-account-popup-trigger]');
      const accountDirect = root.querySelector('[data-c24h-account-code-direct]');
      const popup = root.querySelector('[data-c24h-account-popup]');

      root.querySelectorAll('[data-c24h-access-role="secondary"]').forEach((item) => {
        item.hidden = granted;
      });

      // Un cliente ya logueado que obtiene acceso por código no necesita volver a iniciar sesión.
      // En ese caso cambiamos el trigger del popup por el acceso directo a Mi cuenta.
      if (accountDirect) {
        accountDirect.hidden = !granted;
        if (popupTrigger) popupTrigger.hidden = granted;
        if (granted && popupTrigger && popup) closePopup(popupTrigger, popup, false);
      }
    });

    scope.querySelectorAll('[data-c24h-mobile-account-actions]').forEach((container) => {
      const granted = codeAccessIsGranted(container);
      container.querySelectorAll('[data-c24h-access-role="secondary"]').forEach((item) => {
        item.hidden = granted;
      });
      container.querySelectorAll('[data-c24h-access-role="account"]').forEach((item) => {
        item.hidden = !granted;
      });
    });
  };

  const bindPopup = (toggle) => {
    if (!toggle || toggle.dataset.accountPopupBound === 'true') return;

    const popupId = toggle.getAttribute('aria-controls');
    const popup = popupId ? document.getElementById(popupId) : null;
    if (!popup) return;

    toggle.dataset.accountPopupBound = 'true';
    const closeButton = popup.querySelector('.account-popup__close');

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = popup.hidden;
      popup.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen && closeButton) closeButton.focus();
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => closePopup(toggle, popup, true));
    }

    document.addEventListener('click', (event) => {
      if (popup.hidden) return;
      if (!popup.contains(event.target) && !toggle.contains(event.target)) {
        closePopup(toggle, popup, false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup(toggle, popup, true);
      }
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.account-toggle[data-c24h-account-popup-trigger]').forEach(bindPopup);
    syncAccessState(scope);
  };

  const boot = () => {
    init(document);

    // El sistema C24H ya convierte un código válido almacenado en localStorage en
    // html.c24h-access-granted. Observamos esa clase para evitar duplicar la lógica
    // criptográfica, la caducidad o la clave privada de almacenamiento.
    const observer = new MutationObserver(() => syncAccessState(document));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
